import { getSupabaseClient } from './supabase.client.js';

/**
 * Repositorio de configuración (`site_config`) para el panel de staff.
 * Habla con Supabase SOLO a través del cliente anon de navegador
 * (`supabase.client.js`); el acceso lo enforcea RLS
 * (`site_config_admin_write` para escrituras, lectura pública).
 * Este es el ÚNICO módulo que emite queries Supabase para site_config.
 */

/**
 * Lee el flag `publi_enabled` de `site_config`.
 *
 * Si Supabase no está configurado devuelve `false` — la publi se oculta
 * por default si no hay backend.
 * @returns {Promise<boolean>}
 * @throws {Error} si Supabase responde con error
 */
export async function getPubliEnabled() {
    const client = getSupabaseClient();
    if (!client) return false;

    const { data, error } = await client
        .from('site_config')
        .select('value')
        .eq('key', 'publi_enabled')
        .single();

    if (error) throw new Error(error.message);
    return data?.value ?? false;
}

/**
 * Escribe el flag `publi_enabled` en `site_config`.
 *
 * @param {boolean} next — el nuevo valor (true/false)
 * @returns {Promise<void>}
 * @throws {Error} si Supabase no está configurado o la query falla
 */
export async function setPubliEnabled(next) {
    const client = getSupabaseClient();
    if (!client) throw new Error('Actualización no disponible');

    const { error } = await client
        .from('site_config')
        .update({ value: next })
        .eq('key', 'publi_enabled');

    if (error) throw new Error(error.message);
}
